import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import BidDetails from '../components/BidDetails'
import Footer from '../components/Footer'
import ScrollToTop from '../components/ScrollToTop'

function BidDetailsPage() {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    return (
        <div>
            <ScrollToTop />
            <Sidebar isOpen={isOpen} toggle={toggle} />

            <Navbar toggle={toggle} />

            <BidDetails />

            <Footer />
        </div>
    )
}

export default BidDetailsPage